import React from 'react';

const CustomS = () => (
  <div
    style={
      {
        fontFamily: 'Instrument Sans Bold',
        fontSize: '225px',
        lineHeight: 1,
        fontWeight: 900,
        transform: 'translateX(-40px)',
        WebkitTextStroke: '12px currentColor',
        WebkitTextStrokeWidth: '12px',
        WebkitTextStrokeColor: 'currentColor',
        textStroke: '12px currentColor',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any
    }
  >
    S
  </div>
);

export default CustomS;
